<template>
  <div class="container" style="min-width: 900px">
    <p style="font-size:26px;display: inline-block;cursor:pointer">其他</p>
  </div>
</template>

<script>
    export default {
        name: "otherMaterial"
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// otherMaterial.vue?802253f0